var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":true,"title":_vm.$t('Upload de arquivos'),"centered":"","id":"modal-suporte-upload","no-close-on-backdrop":true,"no-close-on-esc":true,"size":"xl"},on:{"hidden":function($event){return _vm.$emit('completed')}}},[_c('div',{staticClass:"modal-body px-0"},[_c('div',{staticClass:"row"},[_c('dashboard',{staticClass:"col-12",attrs:{"uppy":_vm.uppy,"plugins":[
                    'Webcam',
                    // 'GoogleDrive',
                    // 'Dropbox',
                    // 'Instagram',
                    // 'Facebook',
                    // 'OneDrive',
                    // 'Zoom',
                    // 'Unsplash',
                    // 'Box',
                    'ImageEditor',
                    // 'Url',
                    'Audio',
                    'ScreenCapture',
                    'DragDrop',
                    'ThumbnailGenerator',
                    // 'Tus',
                    // 'DropTarget',
                    // 'GoldenRetriever',
                    // 'Compressor',
                    // 'ProgressBar',
                ],"props":{ theme: 'light' }}}),_vm._v(" "),_c('div',{staticClass:"UppyProgressBar"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }